import Header from "../DashboardMontadorComponents/Header"
export function MontadorProfileForm({
  title,
  children,
}) {
  return (
    <>
      <Header title={title} />
      {children}
    </>
  )
}